export const standardSizeInput = {
    small: 40,
    medium: 56,
    large: 72,
    default: 40,
}
